


























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import { differenceInMinutesBetweenDates, getTimeSince } from "@/utils/date-helpers";

/**
 * Character short synchronization status component.
 */
@Component
export default class CharacterSynchronizationStatus extends Vue {
	// Injections
	differenceInMinutesBetweenDates = differenceInMinutesBetweenDates;
	getTimeSince = getTimeSince;

	@Prop()
	now!: Date;

	@Prop()
	lastSyncTime!: string;
}
